import type { ICampaign } from "../../../../types/models/campaign.models.types";
import { usePutHttp } from "../../http.hook";

interface IResponse {
  campaign: ICampaign;
}

export function useMakeCampaignLiveAdminHttp() {
  return usePutHttp<null, IResponse>({
    path: "/admin/campaigns/:id/make-live",
  });
}
